import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Wrapper from '../layouts/Wrapper';
import Banner from '../components/laboratory/Banner';
import SectionsInfo from '../components/SectionsInfo';
import CustomAccordion from '../components/laboratory/CustomAccordion';
import Spinner from '../components/Spinner';
import { getDiagnosticPage, getDiagnosticPageStaff } from '../store/actions/diagnosticPage';
import removeHtmlTags from '../helpers/removeHtmlTags';
import OurTeam from '../components/home/OurTeam';

function DiagnosticCenter() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.diagnosticPage);
  const { staff, staffLoading } = useSelector((state) => state.diagnosticPage);
  useEffect(() => {
    dispatch(getDiagnosticPageStaff());
    dispatch(getDiagnosticPage());
  }, []);
  return (
    <Wrapper>
      {!loading && !staffLoading ? (
        <div className="container medium">
          <Banner
            title={data.diagnosticCenter.title[lang]}
            description={removeHtmlTags(data.diagnosticCenter.summary[lang])}
            bannerImage={data.diagnosticCenter.image ? data.diagnosticCenter.image.webp_url : ''}
          />
          <div className="rooms_content">
            <SectionsInfo
              isSlider={false}
              isPartner={false}
              title={data?.diagnosticCenter?.two_blog_title ? data.diagnosticCenter.two_blog_title[lang] : ''}
            />
            <CustomAccordion data={data.diagnosticCenterServiceList} room="diagnostics" />
          </div>
          <OurTeam isDiagnosticCenter data={{ data: staff }} />
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default DiagnosticCenter;
